import type { SupportTicketQueryScope } from "@redotech/redo-support-v2/query/support-ticket-query-keys";
import { useContext, useMemo } from "react";
import { AuthContext } from "../auth";
import { TeamContext } from "../team";

export function useSupportTicketQueryScope(): SupportTicketQueryScope {
  const auth = useContext(AuthContext);
  const team = useContext(TeamContext);

  return useMemo(
    () => ({
      accountId: team?.accountId ?? null,
      teamId: auth?.teamId ?? team?._id ?? null,
    }),
    [auth?.teamId, team?._id, team?.accountId],
  );
}
